import React, {Component} from 'react'
import { connect } from 'react-redux'

// Utils
import { hasAccess, hasSubscriptionPermission } from '../../../utils/auth'
import EventEmitter from '../../../utils/events'
import { translation } from '../../../utils/helpers'
import { DracarAllowOrderTypes, AccountingSystemTypes } from '../../../constants'

import { getInvoiceStatus } from '../../../actions/invoicing'
import { SparePartModuleIcons, InvoiceIcons } from '../../elements/icons'

// Components
import InvoicePopup from '../InvoicePopup'
import StatusBox from '../StatusBox'

// Elements
import PanelHeader from '../../elements/panelHeader'

// import styles
import './invoice.scss'
// import Grid from '../../elements/grid'
// import Icon from '../../elements/icon'
// import Button from '../../elements/button'

class Invoice extends Component {
  constructor (props) {
    super(props)
    this.state = {
      invoiceItem: {},
      showInvoicePopup: false,
      showCommentNotice: false,
      showAddonNotice: false,
      showSpinner: {
        invoicing: false
      }
    }
    this.renderInvoiceStatus = this.renderInvoiceStatus.bind(this)
    this.updateOrder = this.updateOrder.bind(this)
    this.updateInvoiceItem = this.updateInvoiceItem.bind(this)
    this.showSpinner = this.showSpinner.bind(this)
    this.updateFromSocket = this.updateFromSocket.bind(this)

    this.updating = false
  }

  componentDidMount () {
    EventEmitter.addListener('ORDER_SOCKET', this.updateFromSocket, this)
    this.updateInvoiceItem(this.props)
  }

  componentWillReceiveProps (newProps) {
    this.updateInvoiceItem(newProps)
  }

  componentWillUnmount () {
    EventEmitter.removeListener('ORDER_SOCKET', this.updateFromSocket)
  }

  updateFromSocket (json) {
    // console.log('Invoice component - updateFromSocket', json)
    if (json.Type === 'ORDER_UPDATE' && json.Data !== undefined && json.Data !== null && json.Data.Id === this.state.invoiceItem.Id) {
      // if (json.DeviceToken === this.props.auth.user.DeviceToken) return
      // Above prevented updating state after invoicing (invoicing returns empty string on success) - this lets the component get the invoicing socket msg.
      this.setState({
        invoiceItem: {
          ...this.state.invoiceItem,
          ...json.Data
        }
      })
    }
  }

  updateInvoiceItem (props) {
    let invoiceItem = {...this.state.invoiceItem}
    if (props.invoiceOrder !== undefined) {
      invoiceItem = props.invoiceOrder
      this.setState({
        invoiceItem: invoiceItem,
        showCommentNotice: true,
        showAddonNotice: true
      })
    } else if (props.invoiceOrderId !== undefined) {
      if (!this.updating) { // Prevent component from spamming requests to API.
        this.updating = true
        this.props.getInvoiceStatus(props.invoiceOrderId).then((res) => {
          this.updating = false
          invoiceItem = res.data
          // console.log('updateInvoiceItem: get invoice status res.data ', res.data)
          this.setState({
            invoiceItem: invoiceItem,
            showCommentNotice: true,
            showAddonNotice: true
          })
        })
      }
    }
  }

  updateOrder (data) {
    if (this.props.updateOrder !== undefined) {
      this.props.updateOrder(data)
      console.log('Invoice component: data in update order ', data)
    }
    this.setState({
      invoiceItem: data
    })
    // if (this.props.updateOrder === undefined) {

    //   this.updateInvoiceItem()
    // }
  }

  showSpinner (element, enabled) {
    let spinner = this.state.showSpinner
    spinner[element] = enabled
    this.setState({
      showSpinner: spinner
    })
  }

  renderInvoiceStatus () {
    if (this.state.showSpinner.invoicing === true) {
      return ([
        <div className='divider' key='1' />,
        <div className='invoice' key='2'>
          <span className='animated-background'>
            <i className='fa fa-spinner fa-spin fa-2x fa-fw' />
          </span>
        </div>
      ])
    }

    let iswp = hasAccess([6], this.props.auth.user.UserType)
    let isReady = (!iswp && this.state.invoiceItem.ReadyForInvoice === 1) || (iswp && this.state.invoiceItem.ReadyForInvoiceByWP)
    let isMarked = (!iswp && this.state.invoiceItem.IsMarkInvoiced) || (iswp && this.state.invoiceItem.IsMarkInvoicedByWP)
    let isInvoiced = (!iswp && this.state.invoiceItem.IsInvoiced) || (iswp && this.state.invoiceItem.IsInvoicedByWP)
    // let hasAddon = this.props.invoiceOrder.HasAddonPrice
    let dracarNonMatchesFound = this.state.invoiceItem ? this.state.invoiceItem.DracarNonMatchingPartsExists : false
    let invoiceStatusIsResat = this.state.invoiceItem.InvoiceStatusIsResat
    let invoiceIcon = SparePartModuleIcons.Attention
    let invoiceText = '1140'
    let invoiceColor = 'orange'
    // Dracar check - no need to worry about spare parts, if they do not use Dracar
    if (!this.props.auth.permissions.DracarUsable) {
      dracarNonMatchesFound = false
    }

    // Ready for invoice
    if (isReady) {
      invoiceText = '1139'
      invoiceIcon = SparePartModuleIcons.Attention

      // Invoice status reset
      if (invoiceStatusIsResat) { // if it is resat and approved
        invoiceIcon = SparePartModuleIcons.Attention
        invoiceText = translation('15003')
      }
    } else {
      // Invoice status reset
      if (invoiceStatusIsResat) { // if it is resat and not approved
        invoiceIcon = SparePartModuleIcons.Attention
        invoiceText = translation('15006')
      }
    }
    if (isMarked) {
      invoiceText = '13510'
      invoiceIcon = SparePartModuleIcons.OK
      invoiceColor = 'green'
    }
    if (isInvoiced && !isMarked) {
      invoiceText = '13511'
      invoiceIcon = SparePartModuleIcons.OK
      invoiceColor = 'green'
    }

    // Is invoiced and marked
    if (isInvoiced && isMarked && !invoiceStatusIsResat) {
      invoiceText = '13512'
      invoiceIcon = SparePartModuleIcons.OK
      invoiceColor = 'green'
    }

    // console.log('isReady - isInvoiced - isMarked - invoiceStatusIsResat ', isReady, isInvoiced, isMarked, invoiceStatusIsResat)
    if (dracarNonMatchesFound && this.props.auth.accountingSystem === AccountingSystemTypes.Dracar && DracarAllowOrderTypes.includes(this.state.invoiceItem.OrderType)) {
      invoiceIcon = InvoiceIcons.Total_Price
      invoiceText = '1140'
    }

    const invoicePopup = (close) => {
      if (this.state.invoiceItem.IsWrecked) window.toastr.error(translation('16663'), translation('216'))
      else {
        this.setState({
          showInvoicePopup: !this.state.showInvoicePopup
        })
      }
    }

    let action
    if ((hasSubscriptionPermission(this.props.auth, 10, 30)) || (hasSubscriptionPermission(this.props.auth, 10, 6) && isReady && !(isMarked && isInvoiced))) {
      action = invoicePopup
    }

    return (
      <StatusBox
        onClick={!(isMarked && isInvoiced) ? action : null}
        icon={invoiceIcon}
        color={invoiceColor}
        title={translation(13486).toUpperCase()}
        subTitle={translation(invoiceText)}
        chevron={this.state.showInvoicePopup}
      />
    )
  }

  render () {
    let isDraft = this.props.auth.departmentType !== 1 ? this.state.invoiceItem.IsDraft : this.state.invoiceItem.BodyShopIsDraft
    if (isDraft) return null
    if (!hasAccess([3, 5, 6, 7], this.props.auth.user.UserType)) return null
    if (!hasSubscriptionPermission(this.props.auth, 10)) return null
    let isWp = hasAccess([6], this.props.auth.user.UserType)
    let { invoiceItem } = this.state
    let dracarSettings

    // Should be moved to backend, when this component gets reworked
    if (this.props.auth.permissions.DracarUsable) {
      dracarSettings = {
        dracarNonMatchesFound: invoiceItem.DracarNonMatchingPartsExists,
        dracarOrderSet: invoiceItem.DracarRepairOrderSet,
        dracarActive: this.props.auth.permissions.DracarAllowed,
        isDracarOtherOrder: !DracarAllowOrderTypes.includes(invoiceItem.OrderType), // other orderType order when using Dracar
        isRpReport: invoiceItem.ReportType === 2
      }
    }

    // do not invoice permanently referred out orders
    if (!isWp && invoiceItem.IsReferredOut && invoiceItem.OrderConnection !== undefined && invoiceItem.OrderConnection !== null) {
      if (invoiceItem.OrderConnection.MoveType !== undefined && invoiceItem.OrderConnection.MoveType !== null && invoiceItem.OrderConnection.MoveType === 1) {
        let referredName = invoiceItem.OrderConnection.TransferedToCompanyName
        if (invoiceItem.OrderConnection.TransferedToCompanyName === undefined || invoiceItem.OrderConnection.TransferedToCompanyName === null) {
          referredName = ''
        }
        let referText = translation('15355').replace('[company]', referredName)
        return (
          <div>
            <PanelHeader text='' />
            <ul className='white__box invoice_wrapper'>
              <label className='no_invoice'>{referText}</label>
            </ul>
          </div>
        )
      }
    }

    const onClose = () => {
      this.setState({showInvoicePopup: false})
    }

    return (
      <div>
        {this.props.hasHeader && <PanelHeader text='' />}
        <div className='white__box invoice_wrapper'>
          {!isDraft && this.renderInvoiceStatus()}
          {this.state.invoiceItem.IsOldReferral && (
            <li className='migrated-flag'>
              <p>{translation(534)}</p>
              <p>{translation(16413)}</p>
            </li>
          )}
        </div>{this.state.showInvoicePopup && (
          <div className='invoicePopup_container'>
            <InvoicePopup
              item={this.state.invoiceItem}
              updateOrder={this.updateOrder}
              close={onClose}
              showSpinner={this.showSpinner}
              dracarSettings={dracarSettings}
            />
          </div>
        )}
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth,
    common: state.common
  }
}

export default connect(mapStateToProps, {
  getInvoiceStatus
})(Invoice)



// WEBPACK FOOTER //
// ./src/app/shared/components/Invoice/index.js